<template>
  <div>
    <DeleteConfirmationModal
      :show="showConfirmRequestViewModal"
      :maxWidth="454"
      :title="$t('common.cancel_validation_request')"
      :text="$t('common.are_you_sure_you_want_to_cancel')"
      :cancelText="$t('common.button.close')"
      :confirmText="$t('common.button.yes_cancel')"
      @cancel="showConfirmRequestViewModal = false"
      @delete="handleCancelRequest"
    />
    <ValidationCard
      color="yellow lighten-2"
      :by="requestedBy"
      :date="requestedAt"
      :icon="icon"
      :assignee="assignee"
      :title="$t('rev.validation.validation_requested')"
    >
      <template v-slot:actions>
        <v-divider class="mx-6" />
        <v-card-actions class="d-flex justify-end px-6 py-3">
          <v-btn color="primary" text rounded @click="onCancelRequest">{{
            $t('common.button.cancel_request')
          }}</v-btn>
          <v-btn
            v-if="canDoFinancialValidation"
            elevation="0"
            color="primary"
            rounded
            max-height="30"
            @click="$emit('validate')"
          >
            <v-icon class="mx-2" color="white" size="16"
              >mdi-check-decagram</v-icon
            >
            {{ $t('rev.header.validate_rev') }}</v-btn
          >
        </v-card-actions>
      </template>
    </ValidationCard>
  </div>
</template>

<script>
import ValidationCard from './ValidationCard'
import DeleteConfirmationModal from '@/components/Modals/DeleteConfirmationModal.vue'

import { utils } from 'frontend-js-shared'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

export default {
  name: 'RequestValidationCard',

  components: { ValidationCard, DeleteConfirmationModal },

  mixins: [trackerMixin],

  props: ['rev', 'canDoFinancialValidation'],

  data() {
    return {
      showConfirmRequestViewModal: false,
      icon: {
        name: 'mdi-alert-decagram',
        color: 'yellow',
      },
    }
  },

  computed: {
    assignee() {
      return this.requestValidationInProgress?.assignees?.[0] ?? null
    },

    requestedAt() {
      const date = this.requestValidationInProgress?.createdAt
      return utils.dates.humanDate(date)
    },

    requestedBy() {
      return this.requestValidationInProgress?.createdBy
    },

    requestValidationInProgress() {
      return this.rev?.validationRequest?.find(
        validationRequest =>
          validationRequest?.status ===
          this.$constants.validationRequestStatus.inProgress
      )
    },
  },

  methods: {
    handleCancelRequest() {
      this.trackValidationRequest({
        action: 'cancelConfirm',
        type: 'buttonClick',
      })
      this.$emit('cancelValidationRequest', {
        status: this.$constants.validationRequestStatus.canceled,
        requestId: this.requestValidationInProgress.id,
      })
      this.showConfirmRequestViewModal = false
    },

    onCancelRequest() {
      this.trackValidationRequest({
        action: 'cancel',
        type: 'buttonClick',
      })
      this.showConfirmRequestViewModal = true
    },
  },
}
</script>
